export const commonTranslations = {
    km: 'km',
    model: 'Model',
    customer_support_feedback: 'Customer support & Feedback',
    technical_error: 'Technical error, please try again later',
    price_validate_zero: 'Price must be greater than Zero.',
    price_validate: 'Minimum Price cannot be greater than the Maximum Price.',
    invalid_request: 'Page not found. Please check the page URL.',
    no_record_found: 'Sorry, no record found for this criteria',
    pcs: 'pcs',
    month_short: 'mon',
    add_to_favourite: 'Add to Favorites',
    add_to_favourite_double_line: 'Add to<br />Favorites',
    remove_from_favourite: 'Remove from favorites',
    remove_from_favourite_double_line: 'Remove from<br />favorites',
    added_to_compare_single_line: 'Added to Comparison',
    added_to_compare: 'Added to<br />Comparison',
    add_to_compare_single_line: 'Add to Comparison',
    add_compare_single: 'Comparison',
    hide_from_search: 'Hide from results',
    add_to_compare: 'Add to<br />Comparison',
    show_less: 'Show less',
    show_more: 'Show more',
    missing_mandatory: 'Mandatory field/s can not be empty',
    delete_confirmation: 'Are you sure you want to delete this record?',
    finance_offer: 'Financing offer',
    finance_offer_short: 'offer',
    select: 'Select',
    show_result: 'Show results',
    make: 'Make',
    town: 'Town',
    no_result_text: 'No search results',
    no_lower_limit: 'No lower limit',
    no_upper_limit: 'No upper limit',
    filter_cannot_use_with_id: 'ID filtering can´t be used with other criteria',
    clear_previous_search: 'Clear previous searches',
    previous_search: 'Previous searches',
    any: 'Any',
    invalid_email: 'The email address you have specified here appears invalid, please check and correct.',
    invalid_max_emails: 'You can add maximum 10 email addresses.',
    invalid_name: 'Name field is mandatory.',
    invalid_phone: 'Please check and correct your telephone number.',
    blank_form_submit_text: 'Blank form can not be submitted',
    email_more_than_ten: 'You can add maximum 10 email addresses.',
    select_minimum_ad_text: 'Please select at least 1 Vehicle to sent its vehicle Information link',
    country_finland: 'Finland',
    message_length_error: 'The message length is between 1 - 1000 characters.',
    month_names: {
        1: 'January',
        2: 'February',
        3: 'March',
        4: 'April',
        5: 'May',
        6: 'June',
        7: 'July',
        8: 'August',
        9: 'September',
        10: 'October',
        11: 'November',
        12: 'December',
    },
    month_short_names: {
        1: 'Jan',
        2: 'Feb',
        3: 'Mar',
        4: 'Apr',
        5: 'May',
        6: 'Jun',
        7: 'Jul',
        8: 'Aug',
        9: 'Sep',
        10: 'Oct',
        11: 'Nov',
        12: 'Dec',
    },
    days_long: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
    days: {
        monday: 'Mon',
        tuesday: 'Tue',
        wednesday: 'Wed',
        thursday: 'Thu',
        friday: 'Fri',
        saturday: 'Sat',
        sunday: 'Sun',
    },
    year: 'Year',
    ad_detail: {
        contact: {
            add_favorite_dealer: 'Add as Favorite dealer',
            remove_favorite_dealer: 'Favorite Dealer (remove)',
        },
        finance: {
            error: {
                autoraha_max_loan_amount: 'Maximum amount of loan is 100 000€',
                autoraha_min_loan_amount: 'Minimum amount of loan is 3 000€',
                etua_max_loan_amount: 'Maximum amount of loan is 100 000€',
                etua_min_loan_amount: 'Minimum amount of loan is 500€',
                kattokorko_max_loan_amount: 'Maximum amount of loan is 100 000€',
                kattokorko_min_loan_amount: 'Minimum amount of loan is 500€',
                op_max_amount: 'Maximum amount of loan is ',
                op_min_amount: 'Minimum amount of loan is ',
                rahoituskumppani_min_loan_amount: 'Minimum amount of loan is 51',
                santander_max_loan_amount: 'Maximum amount of loan is 50 000€',
                santander_min_loan_amount: 'Minimum amount of loan is 2000€',
                rahoitustie_min_loan_amount: 'Pienin lainasumma voi olla 500€',
                spankki_min_loan_amount: 'Minimum amount of loan is 5 000€',
                spankki_max_loan_amount: 'Maximum amount of loan is 50 000€',
            },
        },
        print_stats: {
            dont_report_twice: 'You can not report twice for an Ad',
        },
    },
    ad_post: {
        saved: 'Changes saved',
        saving: 'Saving',
        type_engine_model: 'Type engine model here',
        charging_type: 'Charging Type',
        quick_list: 'Quick list',
        calendar: {
            day: 'day',
            days: 'days',
            next: 'Next»',
            previous: '«Previous',
            week: 'week',
        },
        error_message: {
            address: 'Address is too short, please check address.',
            country: 'Please select country.',
            delivery_cost: 'Office fee must be a number higher than 0.',
            delivery_cost_or_not_price: 'Please enter Office fee or select No office fees.',
            domicile: 'Please select domicile.',
            fuel_type: 'Please select power type.',
            make: 'Please select make.',
            no_image: 'Please attach at least one photo of the vehicle.',
            price: 'Price can only include numbers and max. 9 characters.',
            price_or_not_price: 'Please select asking price or not priced.',
            price_rent: 'Please enter rent price per week.',
            town: 'Please select town.',
            vin: 'Please check VIN.',
            year: 'Please select year model.',
            year_model_text: "Are you sure, that the vehicle's year model is current year?",
            numeric_format: 'Please enter numeric values only.',
            power: 'Please enter power in numeric form.',
            register_number: 'Please give registration number or vehicle identification number (VIN)',
            road_worthy: 'Please select road capacity.',
            color: 'Please select color.',
            color_type: 'Please select color type.',
            drive_type: 'Please select drive type.',
            engine_size: 'Please select engine size.',
            gear_type: 'Please select gearbox type.',
            model: 'Please select model.',
            mileage: 'Please give mileage in numeric form. Mileage cannot be 0.',
            mileage_invalid: 'Please check mileage.',
            invalid_reg_no: 'Please check registration number.',
            invalid_reg_no_or_vin: 'Please check registration number or VIN.',
            location_text: 'Please select location.',
            first_register_date: 'Please select year and month.',
            inspection_date: 'Selected date cannot be in the future.',
            inspection_month: 'Please select year and month.',
            too_new_inspection: 'If no inspections have yet been done, leave the date empty.',
            model_type_word_length: 'Character maximum per single word is 21.',
            missing_mandatory: 'Mandatory field/s can not be empty',
            warranty: 'Please give warranty as numbers.',
            warranty_date: 'Please give warranty end date as dd.mm.yyyy or mm.yyyy.',
            usp_info_limit: 'Vehicle unique selling points cannot be more than 200 characters long',
            first_usage_date: 'Please enter first usage date in dd.mm.yyyy format.',
        },
        image_360: {
            attachment_text: 'Image added successfully',
            attachment_text_second: 'Maximum (2 images) added',
            invalid_url: 'Unable to validate URL. Please check the link',
        },
        video: {
            delete_instruction: 'Are you sure you want to delete the video for this ad ?',
            invalid_url: 'Enter proper video url!',
        },
    },
    ad_review: {
        read_more: 'Read More',
        show_less: 'Less',
        thanks_for_feedback: 'Thanks for your feedback!',
        error_message: {
            select_star: 'Please rate each aspect.',
            selected_all_five:
                'You rated all aspects of this model 5/5. Please explain more specifically in words, what makes it so good.',
            selected_all_one:
                'You rated all aspects of this model 1/5. Please explain more specifically in words, what makes it so poor.',
            select_make: 'Please select make.',
            select_model: 'Please select model.',
            year: 'Please select year model.',
        },
    },
    ad_status_change: {
        showcase_warning:
            'Your ad has active Showcase promotion. Changing the ad status will disable it. Do you want to continue?',
        upsell_showcase_warning:
            'Your ad has active Fast lane and Showcase promotions. Changing the ad status will disable them. Do you want to continue?',
        upsell_warning:
            'Your ad has active Fast lane promotion. Changing the ad status will disable it. Do you want to continue?',
        error: {
            less_price: 'Price can not be less then 1',
            price: 'Price can only include numbers and max. 9 characters.',
        },
    },
    advance_dealer: {
        edit_cancel_confirm: 'Are you sure, that you want to cancel the editing of the details?',
        footer_logo_limit_error: 'You can select max 10 service logos to display',
        invalid_image_error: 'Please upload valid image',
        no_image_uploaded_error: 'No image uploaded',
        company_info: {
            allow_text_limit_error: 'Title contains maximum 50 characters only.',
        },
        custom_page: {
            page_name_empty_error: 'Please enter page name',
            page_title_empty_error: 'Please enter Free format content page title.',
            page_url_empty_error: 'Please enter Free format content page URL.',
        },
        external_link: {
            invalid_link_detail_error: 'Please enter proper external link detail.',
            text_limit_error: 'External link title contains maximum 20 characters only.',
        },
        front_page_introduction: {
            allow_text_limit_error: 'Advertising information contains maximum 200 characters only',
        },
    },
    advanced_search: {
        outside_finland: 'Outside Finland',
        show_result: 'Search',
        invalid_maximum_value: 'Maximum value should be greater than minimum value',
        invalid_minimum_value: 'Minimum value should be less than maximum value',
        invalid_range_value: 'Allow value between %min% to %max% only',
        multiple: 'Multiple',
    },
    compare: {
        add: 'Add to Compare',
        limit: 'Maximum 10 vehicles is allowed for comparison.',
        remove: 'Remove from compare',
        remove_all: 'All items will be removed from comparison.',
        added_to_compare_listing: 'Added to Comparison',
        title: 'Compare',
    },
    dealer_person: {
        added_success: 'New Sales person added',
        delete_confirm: 'Are you sure you want to delete this record?',
        delete_success: 'Contact details has been deleted successfully.',
        order_change: 'The order successfully changed',
        order_change_error: 'The order can not be changed due to the error',
        rotation_disabled: 'Disabled rotation for sales person',
        rotation_enabled: 'Enabled rotation for sales person',
        updated_success: 'Contact details has been updated successfully.',
        error: {
            address: 'Please check address.',
            city: 'Please check city.',
            enter_mobile_number: 'Please give mobile number to enable Whatsapp messaging.',
            image: 'Please upload valid image',
            invalid_address: 'Address can only contain numbers and letters.',
            invalid_city: 'City can only include letters.',
            invalid_name: 'Name cannot contain numbers or special characters.',
            mobile: 'Please check mobile number.',
            name: 'Please give name.',
            phone: 'Please check phone number.',
            title: 'Title cannot contain numbers or special characters.',
        },
    },
    edit_dealer: {
        contact_request_message: 'Hello,%new_line%I am interested Alma Mobility Dealer Site',
        edit_confirm_cancel: 'Are you sure, that you want to cancel the editing of the details?',
        fair: 'Fair',
        invalid_delivery_cost: 'Invalid delivery cost value, It should be Numeric values (0-9) only',
        invalid_facebook_page_url: 'Please correct the Facebook url',
        invalid_image: 'Please upload valid image',
        long_contact_time_text: 'You can not enter more than 80 charcter',
        long_introduction_text: 'You can not enter more than 500 charcter',
        invalid_alma_password:
            "Password's length must be greater than 8 and less than 128 characters, it has to contain special characters or numbers and both capital (A-Z) and lowercase(a-z) letters.",
        password_mandatory: 'If you want to modify your personal information, password is needed.',
        price_history_message: 'Note that when allowing this, price history will be shown in all your ads',
        short: 'Too Short',
        strong: 'Strong',
        weak: 'Weak',
    },
    favourite: {
        remove_message: 'Do you really want to delete this item from favorites?',
        save_and_show_list: 'Save and show Favorites',
        to_favorite_list: 'To Favorite list',
    },
    feedback: {
        dealer_contact_form: 'Dealer contact form',
        seller_contact_form: 'Seller contact form',
        validate: {
            account_option: 'Choose at least one topic for contact.',
            email_blank: 'Email field is mandatory to fill in',
            invalid_ad_ids: 'Only comma separated Numbers are allowed',
            issue_type: 'Please select Type of issue.',
            mobile_format: 'Please check and correct your mobile number',
            name_blank: 'Name field is mandatory to fill in',
            new_location_company_required: 'Company name is required',
            new_location_address_required: 'Address is required',
            new_location_phone_required: 'Phone number is required',
            new_location_lead_email_required: 'Lead email is required',
            new_location_start_date_required: 'Start date is required',
            new_location_contact_name_required: 'Contact person name is required',
            new_location_contact_email_required: 'Contact person email is required',
            new_location_invalid_email: 'Invalid email address',
            new_location_invalid_phone: 'Invalid phone number',
            new_location_invalid_ad_count: 'Amount of ads must be a valid number',
        },
    },
    login_modal: {
        multiple_email_login:
            'Not possible to sign in with given e-mail address. Please try to login with your username. On problem cases, please contact our customer support.',
        password_login_empty: 'Password or loginid field is empty',
        pending_user:
            'you can not logon to our website because you have not activated your account yet. To activate your account, you must click on activation link which has been sent to your email address, specifed at the time of registering to our website. If you do not have received email containing activation link, click menu Forgot your password? and go to section Need help about Account activation?',
        wrong_password_login:
            'You have entered an incorrect username or password. Keep in mind that the username and password are case sensitive.',
        terminate_user: `Sorry, you can not logon to our website because your account has been terminated by Customer Service. Please contact Customer Service from <a href='${Routing.generate('feedback')}'>Customer support & Feedback</a>for more details`,
        dealerForceUpdate:
            'Details updated successfully. Please log in with your new username and password to access your account.',
    },
    own_ad: {
        select_at_least_one_ad: 'Please select at least 1 ad',
        show_statistic: 'Show statistics',
        hide_statistic: 'Hide statistics',
        payment_receipt: {
            mail_sent: 'Mail sent to your email address successfully',
            error: {
                select_month: 'Please select month',
                select_site: 'Please select site',
                select_year: 'Please select year.',
            },
        },
    },
    promotion_purchase: {
        select_ad: 'Please first select the ad',
        select_fastlane: 'Please select the upsell Campaign',
        select_showcase: 'Please select Showcase',
    },
    search_agent: {
        agent_name_blank: 'Your Search agent name should not be blank.',
        search_agent_disabled:
            'Your Search agent is now disabled and you wont recieve e-mail from us. You can re-activate Search agent anytime.',
        search_agent_enabled:
            'Thank you for your confirmation, now your search agent will remain active for another 8 weeks on %site%.com',
    },
    sell_ad: {
        invalid_outside_finland_ad: 'Ad location must be Finland for verified ad',
        check_register_number: 'Please check registration number',
        oma_seller_post_only:
            'Price estimation in OmaNettix is for private users only. Check services for dealers in almaajo.fi',
        mileage_invalid: 'Please check mileage.',
    },
    pricing_tool: {
        search_instruction:
            'You can search similar items like your purchase or for sale ad with this Pricing Tool. You can search from for sale ads and sold ads. Sold ads are from last %show_period% months. Also you can view only private seller or dealer or even both ads simultanously. Select criteria from list and click Go.',
    },
    alma_tunnus: {
        verification_email_sent: 'Verification email sent.',
    },
    dealer_force_update: {
        enter_username: 'Username field cannot be empty.',
        valid_username:
            'Username must be between 8 and 128 characters and can include letters, numbers, and special characters. It cannot contain spaces.',
        enter_new_password: 'New password field cannot be empty.',
        valid_password:
            'Password must be 8-128 characters, contain both lowercase and uppercase letters, and include at least one number or special character.',
        enter_confirm_password: 'Confirm password field cannot be empty.',
        password_not_match: 'Password fields do not match.',
    },
    smart_sale: {
        testimonial_1:
            'Buyer information was confirmed simultaneously, and the sale was done within 15 minutes, including money transfer.',
        testimonial_2:
            'The effortlessness of creating the bill of sale and the whole sales process - no need to print anything and both buyer and seller knew what was happening at each stage.',
        testimonial_3: 'Secure payment, not having a printer and being able to do everything digitally',
        testimonial_4: 'Secure way to complete the deal. Worked wonderfully and payment arrived quickly!',
        testimonial_5: "Can't think of a better or more reliable way to do this",
    },
    inbox: {
        invalid_price: 'Offer amount is required',
        offer_failed: 'Failed to send offer, please try again',
    },
};
